/* eslint-disable indent */
import React from "react";
import { ViewDetailsHeading } from "../../../../components/ViewDetailsHeading";
import { NameAndHub } from "../NameAndHub";
import { Row, Col } from "antd";

export function ViewDeliveryDetails({ deliveryDetails, id, apiResponse }) {
  let delivery = apiResponse?.premiseDto?.deliveryPincodes;
  return (
    <>
      {" "}
      <ViewDetailsHeading
        text={"Delivery Details"}
        itemkey={3}
        id={id}
        apiResponse={apiResponse}
      />
      <div className="view-basic-details">
        <div className="view-details-header">
          <div className="view-details-header-text">Delivery Details</div>
        </div>

        <Row className="basic-details-view">
          <Col lg={8}>
            <div className="basic-details-container">
              <div>
                <NameAndHub
                  name={"No. of delivery PIN codes"}
                  hub={delivery?.length}
                />
              </div>
            </div>
          </Col>
          <Col lg={8}>
            <div className="basic-details-container">
              <div>
                <NameAndHub
                  name={"CP PIN code"}
                  hub={delivery?.length > 0 && delivery[0]?.cpPincode}
                />
              </div>
            </div>
          </Col>
          <Col lg={8}></Col>
          {delivery?.map((e, idx) => (
            <>
              <Col lg={8} key={idx}>
                <div className="basic-details-container">
                  <div>
                    <NameAndHub
                      name={"Delivery PIN code"}
                      hub={e?.deliveryPin}
                    />
                  </div>
                </div>
              </Col>
              <Col lg={8}>
                <div className="basic-details-container">
                  <div>
                    <NameAndHub
                      key={idx}
                      name={"Area name"}
                      hub={e?.serviceableAreas}
                      // hub={deliveryDetails.areaName1.map((item) =>
                      //   item.pincode === e.pincode
                      //     ? item?.area.areaName + ", "
                      //     : null
                      // )}
                    />
                  </div>
                </div>
              </Col>
              <Col lg={8}></Col>
            </>
          ))}
        </Row>
      </div>
    </>
  );
}
